import { type ShowingTooltipInfo, type TooltipContextShowArgs, type TooltipInfo } from ".";

export const getShowingTooltipInfo = (args: TooltipContextShowArgs): ShowingTooltipInfo => {
  const ti = getTooltipInfo(args.target);
  return {
    props: {
      ...ti.props!,
      delay: undefined,
      tooltip: args.tooltip
    },
    target: args.target
  };
};

export const getTooltipInfo = (target: HTMLElement): TooltipInfo => ({
  props: {
    delay: target.dataset.tooltipDelay ? +target.dataset.tooltipDelay : undefined,
    location: {
      left: 0,
      position: "top",
      top: 0
    },
    pointerPosition: {
      left: 0,
      top: 0
    },
    tooltip: target.dataset.tooltip,
    type: "black"
  },
  target: target
});
